<template>
    <v-data-table
        v-model="selected"
        dense
        :server-items-length="itemsLength"
        :items="data"
        :headers="headers"
        :loading="loading.data"
        :options.sync="options"
        :footer-props="{ 'items-per-page-options': [5,10,15] }"
        show-select
        single-select
    >
       <template v-slot:[`item.created_at`]="{value}">
            {{formatTimestamp(value)}}
        </template>
        <template v-slot:[`item.amount`]="{value}">
            <p-amount :amount="value"></p-amount>
        </template>
        <template v-slot:[`item.state`]="{value}">
            <p-status :state="value"></p-status>
        </template>

    </v-data-table>
</template>

<script>
import moment from 'moment';

import { getCreditNotesList } from "../../services/sales/creditNote";
import PStatus from '../common/PStatus.vue';
import PAmount from '../common/PAmount';

export default {
    components: { PStatus, PAmount },
    name: "CreditNoteDataTable",
    data() {
        return {
            loading: {
                data: false,
            },
            data: [],
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "created_at" },
                { text: "Document Date", value: "date" },
                { text: "Customer", value: "customer", sortable: false},
                { text: "Description", value: "notes", sortable: false},
                { text: "Amount", value: "amount", sortable: false},
                { text: "State", value: "state", sortable: false},
            ],
            options: {
                itemsPerPage: 10
            },
            itemsLength: 0
        };
    },
    props: {
        value: Array,
        search: Object
    },
    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
    watch: {
        options: {
            handler() {
                this.fetchCreditNoteData();
            },
        },
    },
    methods: {
        formatTimestamp(timestamp) {
            return moment(timestamp, true).format("YYYY-MM-DD");
        },
        fetchCreditNoteData() {
            this.loading.data = true;
            let options = {...this.options, ...this.search};
            getCreditNotesList(options)
                .then((response) => {
                    this.data = response.data.data;
                    this.itemsLength = response.data.total;
                })
                .finally(() => (this.loading.data = false));
        },
    },
    created() {

    },
};
</script>
